import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./translations";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'nl', // set locale
    messages, // set locales
})

const app = new Vue({
    el: '#app',
    i18n,
    components: {
        BalanceCheck: () => import('./components/BalanceCheck.vue'),
    },
    mounted() {
        const fpPromise = FingerprintJS.load();

        (async () => {
            const fp = await fpPromise;
            const result = await fp.get();
            window.axios.defaults.headers.common['X-Fraud-Identity'] = result.visitorId;
        })();
    }
});

i18n.locale = document.documentElement.lang;
